import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const dashboardCount = createAsyncThunk('dashboardCount', async (data) => {

    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `userweb_dashboard`,
          
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const dashboardCountSlice = createSlice({
    name: 'dashboardCount',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(dashboardCount.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                state.data = [];
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.data = [];
            }
        });
        builder.addCase(dashboardCount.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default dashboardCountSlice.reducer; 